import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITire } from 'app/shared/model/tire.model';
import { getEntities as getTires } from 'app/entities/tire/tire.reducer';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntity, updateEntity, createEntity, reset } from './tire-truck-implement.reducer';
import { ITireTruckImplement } from 'app/shared/model/tire-truck-implement.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const TireTruckImplementUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const tires = useAppSelector(state => state.tire.entities);
  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const tireTruckImplementEntity = useAppSelector(state => state.tireTruckImplement.entity);
  const loading = useAppSelector(state => state.tireTruckImplement.loading);
  const updating = useAppSelector(state => state.tireTruckImplement.updating);
  const updateSuccess = useAppSelector(state => state.tireTruckImplement.updateSuccess);

  const handleClose = () => {
    props.history.push('/tire-truck-implement' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTires({}));
    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...tireTruckImplementEntity,
      ...values,
      tire: tires.find(it => it.id.toString() === values.tireId.toString()),
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tireTruckImplementEntity,
          tireId: tireTruckImplementEntity?.tire?.id,
          truckImplementId: tireTruckImplementEntity?.truckImplement?.id,
          companyId: tireTruckImplementEntity?.company?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.tireTruckImplement.home.createOrEditLabel" data-cy="TireTruckImplementCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.tireTruckImplement.home.createOrEditLabel">Create or edit a TireTruckImplement</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="tire-truck-implement-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.tireTruckImplement.installVehicleOdometer')}
                id="tire-truck-implement-installVehicleOdometer"
                name="installVehicleOdometer"
                data-cy="installVehicleOdometer"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.tireTruckImplement.installTireOdometer')}
                id="tire-truck-implement-installTireOdometer"
                name="installTireOdometer"
                data-cy="installTireOdometer"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.tireTruckImplement.position')}
                id="tire-truck-implement-position"
                name="position"
                data-cy="position"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.tireTruckImplement.steppe')}
                id="tire-truck-implement-steppe"
                name="steppe"
                data-cy="steppe"
                check
                type="checkbox"
              />
              <ValidatedField
                id="tire-truck-implement-tire"
                name="tireId"
                data-cy="tire"
                label={translate('fleetSenseApp.tireTruckImplement.tire')}
                type="select"
              >
                <option value="" key="0" />
                {tires
                  ? tires.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.identificationCode}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tire-truck-implement-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.tireTruckImplement.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tire-truck-implement-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.tireTruckImplement.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tire-truck-implement" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TireTruckImplementUpdate;
